import { defineStore } from 'pinia';
import { NotificationType } from 'src/core/types/notification';

type NotificationsStore = {
  notifications: NotificationType[];
};

/**
 * A store for managing notifications data.
 */
export const useNotificationsStore = defineStore('notifications', {
  state: () =>
    ({
      notifications: [],
    } as NotificationsStore),

  getters: {
    // getters
  },

  actions: {
    /**
     * Adds a notification to the notifications array.
     * If the notification type is 'loading', it starts a countdown interval to update the loading time until it reaches 1.
     * @param notification - The notification to be added.
     */
    addNotification(notification: NotificationType) {
      if (notification.type === 'loading') {
        const countdownInterval = setInterval(() => {
          const foundNotification = this.notifications.find(
            (n: NotificationType) => n.id === notification.id
          );
          if (
            foundNotification &&
            foundNotification.loadingTime !== undefined
          ) {
            foundNotification.loadingTime += 0.1;
            if (foundNotification.loadingTime >= 1) {
              clearInterval(countdownInterval);
            }
          }
        }, 1000);
      } // TODO delete once backend connected
      // -------------------------------

      this.notifications.push(notification);
    },

    /**
     * Deletes a notification with the specified ID from the notifications array.
     * @param id - The ID of the notification to be deleted.
     */
    deleteNotification(id: number) {
      this.notifications = this.notifications.filter(
        (notification: NotificationType) => notification.id !== id
      );
    },
  },
});
